import { sharedFieldStyles } from 'components/Forms/lib/styles';
import deviceSize from 'constants/deviceSize';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { SColumn } from 'styles/layout';

export const SWrapper = styled(SColumn)`
    gap: 3rem;
    margin-top: 2rem;
    margin-bottom: 4rem;
`;

export const SHeader = styled(SColumn)`
    align-items: center;
    gap: 0.8rem;
    text-align: center;
`;

export const STitle = styled.h1`
    font-size: 2.4rem;
    font-weight: bold;
    color: ${({ theme }) => theme.color.text.main};
    margin: 0;
`;

export const SSubtitle = styled.p`
    font-size: 1.5rem;
    color: ${({ theme }) => theme.color.text.main};
    margin: 0;
`;

export const SSearchBar = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    position: relative;
    max-width: 60rem;
    width: 100%;
    margin: 0 auto;

    input {
        ${sharedFieldStyles}
        height: 4.8rem;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        width: 100%;
        font-size: 1.6rem;
    }

    @media (max-width: ${deviceSize.mobile}px) {
        max-width: 100%;
    }
`;

export const SPremiumBadge = styled.div`
    position: absolute;
    left: -2rem;
    top: 50%;
    transform: translateY(-50%);
`;

export const SPremiumNotice = styled(Link)`
    align-self: center;
    color: ${({ theme }) => theme.color.secondary.main};
    font-size: 1.4rem;
    font-weight: bold;
    text-align: center;
    text-decoration: none;
    white-space: pre-line;

    &:hover {
        text-decoration: underline;
    }
`;

export const SSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const SSectionTitle = styled.h2`
    font-size: 1.8rem;
    font-weight: bold;
    color: ${({ theme }) => theme.color.secondary.main};
    margin: 0;
    text-transform: capitalize;
`;

export const SResultCard = styled(Link)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.4rem 1.8rem;
    background-color: ${({ theme }) => theme.color.white};
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: -4px 5px 8px 0 rgba(0, 116, 151, 0.1), -1px 2px 4px 0 rgba(0, 116, 151, 0.1);
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    user-select: none;
    transition: box-shadow 0.15s ease;

    &:hover {
        box-shadow: -4px 5px 12px 0 rgba(0, 116, 151, 0.2), -1px 2px 6px 0 rgba(0, 116, 151, 0.15);
        text-decoration: none;
    }
`;

export const SResultCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    min-width: 0;
    flex: 1;
`;

export const SResultDate = styled.span`
    font-size: 1.2rem;
    color: ${({ theme }) => theme.color.grey.light};
    white-space: nowrap;
    flex-shrink: 0;
`;

export const SResultTitle = styled.span`
    font-weight: bold;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.color.text.main};
`;

export const SResultSubtitle = styled.span`
    font-size: 1.2rem;
    color: ${({ theme }) => theme.color.grey.light};
`;

export const STagList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 0.2rem;
`;

export const STag = styled.span`
    font-size: 1.1rem;
    color: ${({ theme }) => theme.color.secondary.main};
    background-color: ${({ theme }) => theme.color.grey.light2};
    border-radius: ${({ theme }) => theme.borderRadius};
    padding: 0.2rem 0.8rem;
`;

export const SResultSnippet = styled.p`
    font-size: 1.3rem;
    color: ${({ theme }) => theme.color.text.main};
    margin: 0;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const SEmptyState = styled.p`
    color: ${({ theme }) => theme.color.grey.light};
    font-size: 1.4rem;
    text-align: center;
    padding: 2rem;
`;
